/**
 * @generated SignedSource<<1589716ddd987094167beb9cd040e4b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetKPITileGraphGaugeIndicatorType = "primary" | "secondary";
export type WidgetKPITileGraphGaugePartColor = "negative" | "neutral" | "positive" | "semiNegative";
export type WidgetKPITileGraphGaugePartMode = "lowlight" | "normal";
import { FragmentRefs } from "relay-runtime";
export type Tile_kpiTileGraphGauge$data = {
  readonly gaugeParts: ReadonlyArray<{
    readonly color: WidgetKPITileGraphGaugePartColor;
    readonly mode: WidgetKPITileGraphGaugePartMode;
    readonly value: number;
  }>;
  readonly indicators: ReadonlyArray<{
    readonly type: WidgetKPITileGraphGaugeIndicatorType;
    readonly value: number;
  }>;
  readonly " $fragmentType": "Tile_kpiTileGraphGauge";
};
export type Tile_kpiTileGraphGauge$key = {
  readonly " $data"?: Tile_kpiTileGraphGauge$data;
  readonly " $fragmentSpreads": FragmentRefs<"Tile_kpiTileGraphGauge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Tile_kpiTileGraphGauge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetKPITileGraphGaugePart",
      "kind": "LinkedField",
      "name": "gaugeParts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mode",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetKPITileGraphGaugeIndicator",
      "kind": "LinkedField",
      "name": "indicators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetKPITileGraphGauge",
  "abstractKey": null
};
})();

(node as any).hash = "f3fe8d943667195dd2e516ab62d96c20";

export default node;
